import { MetrikaConfig } from '@/components/analytics/YandexMetrika.types';

const ENV = import.meta.env.MODE;

const configs: Record<string, MetrikaConfig> = {
    development: {
        enabled: false,
        id: null,
        debug: true,
        options: {
            webvisor: false,
            trackLinks: false,
        },
    },

    staging: {
        enabled: true,
        id: import.meta.env.VITE_YANDEX_METRIKA_STAGED_ID,
        debug: true,
        options: {
            webvisor: true,
            trackLinks: true,
        },
    },

    production: {
        enabled: true,
        id: import.meta.env.VITE_YANDEX_METRIKA_ID ?? null,
        debug: false,
        options: {
            webvisor: true,
            trackLinks: true,
            accurateTrackBounce: true,
            trackHash: true,
        },
    },
};

export const getMetrikaConfig = (): MetrikaConfig =>
    configs[ENV] ?? configs.development;
